import { useMutation } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { userService } from '../../services/userService';

export const useDeleteUser = () => {
  return useMutation({
    mutationFn: () =>
      userService.deleteAccount().then(response => {
        const { status, data } = response;
        if (status === 204) {
          return { success: true };
        }

        data?.message && Notify.error({ text: data.message });
        throw new Error(data?.message);
      }),
  });
};
